import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';

@Injectable({
    providedIn: 'root'
})
export class AuthRedirectIfMobileGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _appService: AppService,
        private _tauriService: TauriService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this._appService.isMobileApp || this._tauriService.isTauri) { this._router.navigate(['/auth/mobile/login']); return false; }
        return true;
    }
}
